import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  AccessTimeOutlined,
  BadgeOutlined,
  VisibilityOutlined,
  AttachFile,
} from "@mui/icons-material";
import ReactHtmlParser from "html-react-parser";

import { useAnnouncementDetailContext } from "contexts/AnnouncementDetailContext";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { Link } from "react-router-dom";
import HighlightedText from "components/Shared/HighlightedText";
import { localizeDateTimeMed } from "utils/dateFormats";
import FileIcon from "components/Shared/FileIcon";
import { useAddReactionToAnnouncementMutation } from "store/services/announcementApi";
import { ReactionBar } from "components/Response/ReactionBar";

const AnnouncementBasicDetail = () => {
  const { announcementDetail, loadingAnnouncementDetail } =
    useAnnouncementDetailContext();
  const [addReaction] = useAddReactionToAnnouncementMutation();
  const getGroupedReactions = (reactions = []) => {
  const map = new Map();

  reactions.forEach(({ emoji }) => {
    map.set(emoji, (map.get(emoji) || 0) + 1);
  });

  return Array.from(map.entries());
};
  return !loadingAnnouncementDetail ? (
    <BreadcrumbLayout.Paper>
      <Box padding={3}>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <Typography variant="h6">{announcementDetail?.title}</Typography>
          </Grid>
          <Grid item md={4}>
            <InformationTile
              icon={() => <BadgeOutlined color="primary" />}
              title="Display Name"
              subtitle={announcementDetail?.entity?.name}
            />
          </Grid>
          <Grid item md={4}>
            <InformationTile
              icon={() => <AccountCircleOutlined color="primary" />}
              title="Account"
              subtitle={announcementDetail?.account?.name}
            />
          </Grid>
          <Grid item md={4}>
            <InformationTile
              icon={() => <VisibilityOutlined color="primary" />}
              title="Visible To"
              subtitle={announcementDetail?.visibleTo?.join(", ")}
            />
          </Grid>
          <Grid item md={4}>
            <InformationTile
              icon={() => <AccountCircleOutlined color="primary" />}
              title="Added User"
              subtitle={
                <Link
                  key={announcementDetail?.addedUser?._id}
                  title={announcementDetail?.addedUser?.name}
                  to={`/app/crm/user/${announcementDetail?.addedUser?._id}/detail`}
                  className="line-clamp-2 hover:text-blue-600 hover:underline dark:hover:text-blue-300"
                >
                  <HighlightedText text={announcementDetail?.addedUser?.name} />
                </Link>
              }
            />
          </Grid>
          <Grid item md={4}>
            <InformationTile
              icon={() => <AccessTimeOutlined color="primary" />}
              title="Created At"
              subtitle={localizeDateTimeMed(announcementDetail?.createdAt)}
            />
          </Grid>

          {!!announcementDetail?.attachments?.length && (
            <Grid item md={12}>
              <InformationTile
                icon={() => <AttachFile color="primary" />}
                title="Attachments"
              >
                <div className="flex gap-4">
                  {announcementDetail?.attachments?.map((attachment) => (
                    <a
                      key={attachment?._id}
                      href={attachment?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Open ${attachment?.name} in new tab`}
                      className="text-primary cursor-pointer hover:underline"
                    >
                      <FileIcon
                        fileName={attachment?.name}
                        fileUrl={attachment?.url}
                      />
                    </a>
                  ))}
                </div>
              </InformationTile>
            </Grid>
          )}
        </Grid>
        <br />
        <Box
          style={{
            color: "gray",
            padding: "10px",
          }}
        >
          {ReactHtmlParser(announcementDetail?.content)}
        </Box>
        <Box display="flex" justifyContent="space-between">
          {announcementDetail?.reactions?.length > 0 && (
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {getGroupedReactions(announcementDetail?.reactions).map(([emoji, count]) => (
                      <div
                        key={emoji}
                        className="flex items-center gap-1 text-xs bg-gray-100 rounded-full px-2 py-[2px] border border-gray-300"
                      >
                        <span>{emoji}</span>
                        {count > 1 && <span>{count}</span>}
                      </div>
                    ))}
                  </div>
                )}
                <ReactionBar
                  onReact={(emoji) => {
                    addReaction({
                      id: announcementDetail?._id,
                      
                      emoji,
                    });
                  }}
                />
        </Box>
       

      </Box>
    </BreadcrumbLayout.Paper>
  ) : (
    <InfoGridSkeleton />
  );
};

export default AnnouncementBasicDetail;
